import { useState } from '@wordpress/element';
import { __ } from '@wordpress/i18n';
import { __experimentalToolsPanel as ToolsPanel} from '@wordpress/components';
import {Effect,EffectPanel} from './effect';
import {ImageAnimation,ImageAnimationPanel} from './image-animation';
import {Mask,MaskPanel} from './mask';
import {Ihover,HoverEffectPanel} from './ihover';
import {Infinite,InfiniteEffectPanel} from './infinite';
import {Background,BackgroundEffectPanel} from './background';

{/* <div className='vayu_blocks_animation_panel'>
<VayuBlocksAnimation
    animationData={attributes.animationD
/>
</div> 

ise bhi bej skte ho===
"animationData": {
    "type":"object",
    "default":{
        "effect": {
            "animationValue": "none",
            "effectColor": "#ff0000",
            "effectHover": ""
        },

        "imageAnimation":{
            "animationValue":"none",
            "hover":"with-hvr",
            "speed" : "1s",
        },

        "mask":{
            "maskshape":"none",
            "masksize": "auto",
            "maskposition":"center center",
            "maskrepeat":"no-repeat"
        },
         "infinte":{
            value:"none",
            hovertype:"without-hvr",
        },
        "background":{
            "value":"none",
            "type":"always"
            bg:"",
        }
    }
  }

ye bhi chlega===
"animationData": {
    "type":"object",
        "default":{
            "effect": {},
            "imageAnimation":{},
            "mask":{},
            infinite:{},
            background:{},
        }
    }

ye bhi chlega===
"animationData": {}
*/}

export const VayuBlocksAnimation = ({ 
    animationData = { effect: {}, imageAnimation: {}, mask: {}, hovereffect:{},infinite:{},background:{} },
    dataKey = "animationData",
    onChange
}) => {
    
    const [isVisible, setIsVisible] = useState(false);
    const [popoverAnchor, setPopoverAnchor] = useState();

    const [isImageVisible, setisImageVisible] = useState(false);
    const [imagePopoverAnchor, setImagePopoverAnchor] = useState();

    const [ismaskVisible, setismaskVisible] = useState(false);
    const [maskPopoverAnchor, setmaskPopoverAnchor] = useState();

    const [ishovereffectVisible, setishovereffectVisible] = useState(false);
    const [hovereffectPopoverAnchor, sethovereffectPopoverAnchor] = useState();

    const [isinfiniteVisible, setisinfiniteVisible] = useState(false);
    const [infinitePopoverAnchor, setinfinitePopoverAnchor] = useState();

    const [isbackgroundVisible, setisbackgroundVisible] = useState(false);
    const [backgroundPopoverAnchor, setbackgroundPopoverAnchor] = useState();

    const toggleVisible = () => {setIsVisible((prev) => !prev);};
    const toggleImageVisible = () => {setisImageVisible((prev) => !prev);};
    const togglemaskVisible = () => {setismaskVisible((prev) => !prev);};
    const togglehovereffectVisible = () => {setishovereffectVisible((prev) => !prev);};
    const toggleinfniteVisible = () => {setisinfiniteVisible((prev) => !prev);};
 
    const resetAll = () => {
        const updatedAnimationData = { ...animationData };
    
        for (const key in updatedAnimationData) {
            if (updatedAnimationData.hasOwnProperty(key)) {
                updatedAnimationData[key] = {};
            }
        }
    
	    onChange(dataKey, updatedAnimationData);
    };

    
    return (
        <div className="vayu_blocks_animation_panel">
            
            <ToolsPanel label={__('Animation')} className="vayu_block_animation_name" resetAll={ resetAll }>

                {animationData?.effect && (
                    <EffectPanel
                        animationData={animationData}
                        toggleVisible={toggleVisible}
                        isVisible={isVisible}
                        setPopoverAnchor={setPopoverAnchor}
                        onChange={onChange}
                        dataKey={dataKey}
                    />
                )}

                {animationData?.imageAnimation && (
                    <ImageAnimationPanel
                        animationData={animationData}
                        isImageVisible={isImageVisible}
                        setImagePopoverAnchor={setImagePopoverAnchor}
                        toggleImageVisible={toggleImageVisible}
                        onChange={onChange}
                        dataKey={dataKey}
                    />
                )}

                {animationData?.mask && (
                    <MaskPanel
                        animationData={animationData}
                        setmaskPopoverAnchor={setmaskPopoverAnchor}
                        ismaskVisible={ismaskVisible}
                        togglemaskVisible={togglemaskVisible}
                        onChange={onChange}
                        dataKey={dataKey}
                    />
                )}

                {animationData?.hovereffect && (
                    <HoverEffectPanel
                        animationData={animationData}
                        togglehovereffectVisible={togglehovereffectVisible}
                        ishovereffectVisible={ishovereffectVisible}
                        sethovereffectPopoverAnchor={sethovereffectPopoverAnchor}
                        onChange={onChange}
                        dataKey={dataKey}
                    />
                )}

                {animationData?.infinite && (
                    <InfiniteEffectPanel
                        animationData={animationData}
                        toggleinfniteVisible={toggleinfniteVisible}
                        isinfiniteVisible={isinfiniteVisible}
                        setinfinitePopoverAnchor={setinfinitePopoverAnchor}
                        onChange={onChange}
                        dataKey={dataKey}
                    />
                )}

                {animationData?.background && (
                    <BackgroundEffectPanel
                        animationData={animationData}
                        isbackgroundVisible={isbackgroundVisible}
                        setisbackgroundVisible={setisbackgroundVisible}
                        setbackgroundPopoverAnchor={setbackgroundPopoverAnchor}
                        onChange={onChange}
                        dataKey={dataKey}
                    />
                )}

            </ToolsPanel>

            {/* Effect Component Call */}
            {isVisible && (
                <Effect
                    popoverAnchor={popoverAnchor}
                    setIsVisible={setIsVisible}
                    animationData={animationData}
                    onChange={onChange}
                    dataKey={dataKey}
                />
            )}

            {isImageVisible && (
                <ImageAnimation
                    imagePopoverAnchor={imagePopoverAnchor}
                    setisImageVisible={setisImageVisible}
                    animationData={animationData}
                    onChange={onChange}
                    dataKey={dataKey}
                />
            )}

            {ismaskVisible && (
                <>
                    <Mask
                        maskPopoverAnchor={maskPopoverAnchor}
                        setismaskVisible={setismaskVisible}
                        animationData={animationData}
                        onChange={onChange}
                        dataKey={dataKey}
                    />
                </>
            )}

            {ishovereffectVisible && (
                <>
                    <Ihover
                        hovereffectPopoverAnchor={hovereffectPopoverAnchor}
                        setishovereffectVisible={setishovereffectVisible}
                        animationData={animationData}
                        onChange={onChange}
                        dataKey={dataKey}
                    />
                </>
            )}

            {isinfiniteVisible && (
                <>
                    <Infinite
                        infinitePopoverAnchor={infinitePopoverAnchor}
                        setisinfiniteVisible={setisinfiniteVisible}
                        animationData={animationData}
                        onChange={onChange}
                        dataKey={dataKey}
                    />
                </>
            )}

            {isbackgroundVisible && (
                <>
                <Background
                    backgroundPopoverAnchor={backgroundPopoverAnchor}
                    setisbackgroundVisible={setisbackgroundVisible}
                    animationData={animationData}
                    onChange={onChange}
                    dataKey={dataKey}
                />
            </>
            )}

        </div>
    );
};